if (!customElements.get('product-subscriptions')) {
  class productSubscriptions extends HTMLElement {
    constructor() {
      super()

      this.form = this.closest('form')
      this.buyboxScope = this.closest('[data-buybox-variant]')
      this.sellingPlanInput = this.querySelector('[data-selling-plan-input]')
      this.variantSellingPlanGroupings = this.querySelectorAll('[data-selling-plan-variant-grouping]')
      this.variantIdInput = this.form?.querySelector('input[name="id"]')
      this.sellingPlanOptionWrappers = this.querySelectorAll('[data-selling-plan-wrapper]')
      this.oneTimeSellingPlanOption = this.querySelector('[data-selling-plan][data-radio-type="one_time_purchase"]')
      this.sellingPlanOptions = this.querySelectorAll('[data-selling-plan]')
      this.initialSellingPlanLabel = this.querySelector('[data-initial-selling-plan-label]')
      this.atcButton = (this.buyboxScope || this.form)?.querySelector('[data-buy-buttons-atc]')

      this.oneTimeVariantSelection = this.querySelector('[data-one-time-variant-selection]')
      this.oneTimeVariantSelector = this.querySelector('[data-one-time-variant-selector]')
      this.oneTimeVariantSelectorOptions = this.querySelectorAll('[data-one-time-variant-selector-option]')
      this.oneTimeVariantIndicators = this.querySelectorAll('[data-one-time-variant-indicator]')
      this.oneTimeSavingsIndicators = this.querySelectorAll('[data-one-time-savings-indicator]')
      this.oneTimePriceDisplay = this.querySelector('[data-one-time-price-display]')
      this.freeShippingMessage = (this.buyboxScope || this.form)?.querySelector('[data-free-shipping-message]')
    }

    connectedCallback () {
      if (this.closest('[data-buybox-container]') && !this.closest('.buybox-init')) {
        return
      }
      if (this.atcButton) {
        this.atcButton.disabled = true;
      }

      this.sellingPlanOptions.forEach(sellingPlanOption => {
        sellingPlanOption.addEventListener('change', () => {
          this.toggleSellingPlans(sellingPlanOption)
        })
      })

      const shoppingParam = this.getShoppingParameter()
      const preselectedOption = Array.from(this.sellingPlanOptions).find((option) => option.checked)
      if (shoppingParam) {
        this.handleShoppingParameter(shoppingParam)
      } else if (preselectedOption) {
        this.toggleSellingPlans(preselectedOption)
      } else {
        this.handleDefaultSelection()
      }

      this.setListHeight()

      if (this.oneTimeVariantSelection) {
        this.setupOneTimeVariantSelection()
      }

      this.updateFreeShippingMessage()

      this._boundSetListHeight = () => this.setListHeight()
      this._boundRemoveRechargeWidget = () => this.removeRechargeWidget()
      this._boundJsReady = () => this.classList.add('js-ready')
      window.addEventListener('resize', this._boundSetListHeight)
      window.addEventListener('load', this._boundRemoveRechargeWidget)
      if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', this._boundJsReady)
        this._jsReadyListenerAdded = true
      } else {
        this.classList.add('js-ready')
      }

      this.initializeShopPayInstallments()
      
      if (this.classList.contains('product-subscriptions-v2')) {
        const form = this.closest('form')
        if (form) {
          form.classList.add('has-product-subscriptions-v2')
        }
        this.initializeButtonTextTransform()
        this.updateBuyButtonLabelForSelection()

        if (this.buyboxScope?.dataset.buyboxVariant === 'v3') {
          this.updateV3StrikethroughPrices()
        }
      }
    }
    
    initializeButtonTextTransform() {
      const parentWrapper = this.buyboxScope || this.closest('product-rerender') || this.closest('form')
      const buyButtonPrice = parentWrapper?.querySelector('[data-buy-button-price]')
      if (buyButtonPrice) {
        this.wrapButtonText(buyButtonPrice)
      }
    }
    
    wrapButtonText(buyButtonPrice) {
      if (!this.classList.contains('product-subscriptions-v2')) return
      
      const button = buyButtonPrice.closest('button')
      if (!button) return
      
      const priceSpan = button.querySelector('[data-buy-button-price]')
      if (!priceSpan) return
      
      let textAfterPrice = priceSpan.nextSibling
      while (textAfterPrice && textAfterPrice.nodeType === Node.TEXT_NODE && !textAfterPrice.textContent.trim()) {
        textAfterPrice = textAfterPrice.nextSibling
      }
      
      if (textAfterPrice && textAfterPrice.nodeType === Node.TEXT_NODE && textAfterPrice.textContent.trim()) {
        const textContent = textAfterPrice.textContent.trim()
        const wrapperSpan = document.createElement('span')
        wrapperSpan.className = 'button-text-transform'
        wrapperSpan.textContent = textContent
        textAfterPrice.replaceWith(wrapperSpan)
      } else if (!button.querySelector('.button-text-transform')) {
        const allTextNodes = Array.from(button.childNodes).filter(node => 
          node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        )
        allTextNodes.forEach(textNode => {
          if (textNode.textContent.trim()) {
            const wrapperSpan = document.createElement('span')
            wrapperSpan.className = 'button-text-transform'
            wrapperSpan.textContent = textNode.textContent.trim()
            textNode.replaceWith(wrapperSpan)
          }
        })
      }
    }

    getBuyButtonLabelElement(parentWrapper) {
      const wrapper = parentWrapper || this.buyboxScope || this.closest('product-rerender') || this.closest('form')
      const buyButtonPrice = wrapper?.querySelector('[data-buy-button-price]')

      if (buyButtonPrice) {
        this.wrapButtonText(buyButtonPrice)
      }

      const button = buyButtonPrice?.closest('button') || this.atcButton
      const label = button?.querySelector('.button-text-transform')

      if (label && !label.dataset.defaultBuyButtonLabel) {
        label.dataset.defaultBuyButtonLabel = label.textContent.trim()
      }

      return label
    }

    updateBuyButtonLabel(isOneBottle, parentWrapper) {
      if (!this.classList.contains('product-subscriptions-v2')) return

      const label = this.getBuyButtonLabelElement(parentWrapper)
      if (!label) return

      const defaultLabel = label.dataset.defaultBuyButtonLabel || label.textContent.trim()
      const override = (this.dataset.oneBottleButtonLabel || '').trim()
      label.textContent = isOneBottle && override ? override : defaultLabel
    }

    updateBuyButtonLabelForSelection() {
      const selectedOption = Array.from(this.sellingPlanOptions).find(option => option.checked)
      if (!selectedOption) return

      if (selectedOption.value) {
        const bottleCount = parseInt(selectedOption.getAttribute('data-bottle-count') || '1')
        const productCount = parseInt(selectedOption.getAttribute('data-product-count') || '1')
        this.updateBuyButtonLabel(bottleCount === 1 && productCount === 1)
        return
      }

      const activeIndicator = Array.from(this.oneTimeVariantIndicators).find(indicator => indicator.classList.contains('active'))
      if (!activeIndicator) return

      const bottleCount = parseInt(activeIndicator.getAttribute('data-bottle-count') || '1')
      const productCount = parseInt(activeIndicator.getAttribute('data-product-count') || '1')
      this.updateBuyButtonLabel(bottleCount === 1 && productCount === 1)
    }

    initializeShopPayInstallments() {
      if (this.classList.contains('product-subscriptions-v2')) {
        const oneTimeWrapper = this.querySelector('.product-subscriptions__subscription--one-time')
        const shopPayInstallments = this.querySelector('.product-subscriptions__shop-pay-installments')
        if (shopPayInstallments && !oneTimeWrapper?.contains(shopPayInstallments)) {
          const checkedOption = Array.from(this.sellingPlanOptions).find(option => option.checked)
          if (checkedOption && !checkedOption.value) {
            shopPayInstallments.classList.add('show')
          } else {
            shopPayInstallments.classList.remove('show')
          }
        }
      }
    }

    isMobileDevice() {
      return window.matchMedia('(max-width: 768px)').matches
    }

    getMobileDefaultVariant() {
      if (!this.isMobileDevice()) return null
      
      const mobileDefaultElement = this.querySelector('[data-mobile-default="true"]')
      return mobileDefaultElement ? mobileDefaultElement.dataset.oneTimeVariantIndicator : null
    }

    getShoppingParameter() {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('shopping')
    }

    handleShoppingParameter(shoppingParam) {
      const isOneTime = shoppingParam.includes('otp')
      const bottleCount = shoppingParam.replace('otp', '')
      
      const targetVariant = this.findVariantByBottleCount(bottleCount)
      
      if (!targetVariant) {
        console.warn(`No variant found for bottle count: ${bottleCount}`)
        this.handleDefaultSelection()
        return
      }

      if (isOneTime) {
        this.selectOneTimePurchase(targetVariant.id)
      } else {
        this.selectSubscription(targetVariant.id)
      }
    }

    updateVariantIndicators(variantId) {
      const variantIdStr = variantId != null ? String(variantId) : ''
      this.oneTimeVariantIndicators.forEach((variantIndicator) => {
        const raw = variantIndicator.getAttribute('data-one-time-variant-indicator') ?? variantIndicator.dataset.oneTimeVariantIndicator
        const indicatorId = raw != null && raw !== '' ? String(raw) : ''
        variantIndicator.classList.toggle('active', indicatorId === variantIdStr)
      })

      this.oneTimeSavingsIndicators.forEach((savingsIndicator) => {
        const raw = savingsIndicator.getAttribute('data-one-time-savings-indicator') ?? savingsIndicator.dataset.oneTimeSavingsIndicator
        const savingsId = raw != null && raw !== '' ? String(raw) : ''
        savingsIndicator.classList.toggle('active', savingsId === variantIdStr)
      })
    }

    findVariantByBottleCount(bottleCount) {
      const subscriptionInputs = this.querySelectorAll('[data-radio-type="selling_plan"][data-variant-id]')
      
      for (let input of subscriptionInputs) {
        const variantId = input.dataset.variantId
        const label = input.closest('[data-selling-plan-wrapper]').querySelector('.product-subscriptions__subscription-label')
        
        if (label) {
          const labelText = label.textContent.toLowerCase()
          if (bottleCount === '1' && (labelText.includes('monthly') || labelText.includes('1'))) {
            return { id: variantId }
          } else if (bottleCount === '3' && labelText.includes('3')) {
            return { id: variantId }
          } else if (bottleCount === '6' && labelText.includes('6')) {
            return { id: variantId }
          }
        }
      }
      
      for (let option of this.oneTimeVariantSelectorOptions) {
        const variantId = option.dataset.oneTimeVariantSelectorOption
        const labelText = option.getAttribute('aria-label') || option.textContent || ''
        
        if (bottleCount === '1' && labelText.includes('1 Bottle')) {
          return { id: variantId }
        } else if (bottleCount === '3' && labelText.includes('3 Bottles')) {
          return { id: variantId }
        } else if (bottleCount === '6' && labelText.includes('6 Bottles')) {
          return { id: variantId }
        }
      }
      
      return null
    }

    selectSubscription(variantId) {
      const targetInput = this.querySelector(`[data-radio-type="selling_plan"][data-variant-id="${variantId}"]`)
      
      if (targetInput) {
        targetInput.checked = true
        const changeEvent = new Event('change')
        targetInput.dispatchEvent(changeEvent)
      } else {
        console.warn(`No selling plan input found for variant ID: ${variantId}`)
        this.handleDefaultSelection()
      }
    }

    selectOneTimePurchase(variantId) {
      if (this.oneTimeSellingPlanOption) {
        this.oneTimeSellingPlanOption.checked = true
        this.oneTimeSellingPlanOption.dispatchEvent(new Event('change'))
      }
      
      const targetOption = this.querySelector(`[data-one-time-variant-selector-option="${variantId}"]`)
      if (targetOption) {
        targetOption.checked = true
        const changeEvent = new Event('change')
        targetOption.dispatchEvent(changeEvent)
        
        this.updateVariantIndicators(variantId)
        
        if (this.variantIdInput) this.variantIdInput.value = variantId
        this.changeOneTimePriceDisplay(true)
      } else {
        if (this.variantIdInput) this.variantIdInput.value = variantId
      }
    }

    handleDefaultSelection() {
      const mobileDefaultVariantId = this.getMobileDefaultVariant()
      if (mobileDefaultVariantId) {
        this.updateMobileDefaultDisplay(mobileDefaultVariantId)
        return
      }
      let targetInput = this.querySelector('[data-selling-plan][data-bottle-count="3"]')
      if (!targetInput) {
        const defaultLabel = this.initialSellingPlanLabel || this.sellingPlanOptionWrappers[0]?.querySelector('label')
        const wrapper = defaultLabel?.closest('[data-selling-plan-wrapper]')
        targetInput = wrapper?.querySelector('[data-selling-plan]') || (defaultLabel?.getAttribute('for') && this.querySelector(`#${CSS.escape(defaultLabel.getAttribute('for'))}`))
      }
      if (targetInput) {
        targetInput.checked = true
        targetInput.dispatchEvent(new Event('change'))
      }
    }

    updateMobileDefaultDisplay(variantId) {
      this.updateVariantIndicators(variantId)
      
      if (this.variantIdInput) this.variantIdInput.value = variantId
      this.changeOneTimePriceDisplay(false)
    }

    removeRechargeWidget() {
      const maxAttempts = 15
      let attempts = 0
      this._rechargeInterval = setInterval(() => {
        attempts++
        const rechargeWidget = document.querySelector('.rc-container-wrapper')
        if (rechargeWidget) {
          rechargeWidget.remove()
          clearInterval(this._rechargeInterval)
        } else if (attempts >= maxAttempts) {
          clearInterval(this._rechargeInterval)
        }
      }, 2000)
    }

    toggleSellingPlans(sellingPlanOption) {
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = sellingPlanOption.value
        this.sellingPlanInput.name = sellingPlanOption.value ? 'selling_plan' : ''
      }

      if (this.oneTimeVariantSelection && !sellingPlanOption.value) {
        const selectedOneTimeVariant = this.querySelector('[data-one-time-variant-indicator].active')
        if (selectedOneTimeVariant) {
          if (this.variantIdInput) this.variantIdInput.value = selectedOneTimeVariant.dataset.oneTimeVariantIndicator
          this.changeOneTimePriceDisplay(true)
        }
      } else {
        if (this.variantIdInput) this.variantIdInput.value = sellingPlanOption.dataset.variantId
        this.setBuyButtonPrice(sellingPlanOption)
      }

      const currentlyActiveWrapper = Array.from(this.sellingPlanOptionWrappers).find(wrapper => wrapper.classList.contains('active'))
      const newlySelectedWrapper = Array.from(this.sellingPlanOptionWrappers).find(wrapper => wrapper.contains(sellingPlanOption))
      
      if (this.classList.contains('product-subscriptions-v2') && currentlyActiveWrapper && newlySelectedWrapper && currentlyActiveWrapper !== newlySelectedWrapper) {
        /* CSS Grid 0fr/1fr handles smooth height animation - no JS layout reads needed */
        currentlyActiveWrapper.classList.remove('active')
        newlySelectedWrapper.classList.add('active')
        this.updateFreeShippingMessage()
      } else if (currentlyActiveWrapper && newlySelectedWrapper && currentlyActiveWrapper !== newlySelectedWrapper) {
        const oldBenefitsWrapper = currentlyActiveWrapper.querySelector('.product-subscriptions__benefits-wrapper')
        const newBenefitsWrapper = newlySelectedWrapper.querySelector('.product-subscriptions__benefits-wrapper')
        
        if (oldBenefitsWrapper && newBenefitsWrapper) {
          const oldScrollHeight = oldBenefitsWrapper.scrollHeight
          const newScrollHeight = newBenefitsWrapper.scrollHeight
          
          oldBenefitsWrapper.classList.add('no-transition')
          newBenefitsWrapper.classList.add('no-transition')
          
          currentlyActiveWrapper.classList.remove('active')
          newlySelectedWrapper.classList.add('active')
          
          oldBenefitsWrapper.style.maxHeight = oldScrollHeight + 'px'
          newBenefitsWrapper.style.maxHeight = '0px'
          
          void oldBenefitsWrapper.offsetHeight
          void newBenefitsWrapper.offsetHeight
          
          requestAnimationFrame(() => {
            oldBenefitsWrapper.classList.remove('no-transition')
            newBenefitsWrapper.classList.remove('no-transition')
            
            oldBenefitsWrapper.style.maxHeight = '0px'
            newBenefitsWrapper.style.maxHeight = newScrollHeight + 'px'
            
            this.updateFreeShippingMessage()
            
            const cleanup = () => {
              oldBenefitsWrapper.style.maxHeight = ''
              newBenefitsWrapper.style.maxHeight = ''
              oldBenefitsWrapper.style.willChange = ''
              newBenefitsWrapper.style.willChange = ''
              oldBenefitsWrapper.removeEventListener('transitionend', cleanup)
              newBenefitsWrapper.removeEventListener('transitionend', cleanup)
              this.updateFreeShippingMessage()
            }
            
            oldBenefitsWrapper.style.willChange = 'max-height'
            newBenefitsWrapper.style.willChange = 'max-height'
            oldBenefitsWrapper.addEventListener('transitionend', cleanup, { once: true })
            newBenefitsWrapper.addEventListener('transitionend', cleanup, { once: true })
          })
        } else {
          currentlyActiveWrapper.classList.remove('active')
          newlySelectedWrapper.classList.add('active')
          this.updateFreeShippingMessage()
        }
      } else {
        this.sellingPlanOptionWrappers.forEach(sellingPlanOptionWrapper => {
          sellingPlanOptionWrapper.classList.toggle('active', sellingPlanOptionWrapper.contains(sellingPlanOption))
        })
        this.updateFreeShippingMessage()
      }

      if (this.atcButton) {
        this.atcButton.disabled = false
      }

      if (this.classList.contains('product-subscriptions-v2')) {
        this.updateBuyButtonLabelForSelection()
      }
    }

    updateV3StrikethroughPrices() {
      this.sellingPlanOptions.forEach(option => {
        const compareAtPrice = option.getAttribute('data-variant-compare-at-price')
        const totalDollars = option.getAttribute('data-total-dollars')
        const totalCents = option.getAttribute('data-total-cents-display')

        const label = option.closest('[data-selling-plan-wrapper]') ||
                      this.querySelector(`label[for="${option.id}"]`)?.closest('.product-subscriptions__subscription')
        if (!label) return

        if (compareAtPrice) {
          const strikethrough = label.querySelector('.product-subscriptions__subscription-price-strikethrough s')
          if (strikethrough) {
            strikethrough.textContent = compareAtPrice
          }
        }

        if (totalDollars && totalCents) {
          const dollarEl = label.querySelector('.per-bottle-dollar')
          if (dollarEl) dollarEl.textContent = `${totalDollars}.${totalCents}`
        }
      })
    }

    setBuyButtonPrice(sellingPlanOption) {
      if (!this.classList.contains('product-subscriptions-v2')) {
        const parentWrapper = this.buyboxScope || sellingPlanOption.closest('product-rerender')
        const buyButtonPrice = parentWrapper?.querySelector('[data-buy-button-price]')
        const percentageOffNewVariantPrice = sellingPlanOption.getAttribute('data-percentage-off-newvariantprice');
        if (buyButtonPrice) {
          buyButtonPrice.innerHTML = `${percentageOffNewVariantPrice} &ndash; `
        }
        return
      }

      const parentWrapper = this.buyboxScope || sellingPlanOption.closest('product-rerender')
      const buyButtonPrice = parentWrapper?.querySelector('[data-buy-button-price]')
      if (!buyButtonPrice) return

      const isV3 = this.buyboxScope?.dataset.buyboxVariant === 'v3'

      if (isV3) {
        const totalPrice = sellingPlanOption.getAttribute('data-percentage-off-newvariantprice')
        if (totalPrice) {
          buyButtonPrice.innerHTML = `${totalPrice} &ndash; `
        }
      } else {
        const perBottleDollars = sellingPlanOption.getAttribute('data-per-bottle-dollars')
        const perBottleCentsDisplay = sellingPlanOption.getAttribute('data-per-bottle-cents-display')

        if (perBottleDollars !== null && perBottleCentsDisplay !== null) {
          const perBottlePriceFormatted = `$${perBottleDollars}.${perBottleCentsDisplay} /bottle`
          buyButtonPrice.innerHTML = `${perBottlePriceFormatted} &ndash; `
        }
      }

      const bottleCount = parseInt(sellingPlanOption.getAttribute('data-bottle-count') || '1')
      const productCount = parseInt(sellingPlanOption.getAttribute('data-product-count') || '1')
      this.updateBuyButtonLabel(bottleCount === 1 && productCount === 1, parentWrapper)
    }

    disconnectedCallback() {
      if (this._boundSetListHeight) {
        window.removeEventListener('resize', this._boundSetListHeight)
      }
      if (this._boundRemoveRechargeWidget) {
        window.removeEventListener('load', this._boundRemoveRechargeWidget)
      }
      if (this._jsReadyListenerAdded && this._boundJsReady) {
        window.removeEventListener('DOMContentLoaded', this._boundJsReady)
      }
      if (this._rechargeInterval) {
        clearInterval(this._rechargeInterval)
      }
      this._oneTimeVariantHandlers?.forEach(({ element, handler }) => {
        element.removeEventListener('change', handler)
      })
    }

    setListHeight() {
      this.sellingPlanOptionWrappers.forEach(sellingPlanOptionWrapper => {
        const list = sellingPlanOptionWrapper.querySelector('[data-selling-plan-details]')
        if (!list) { return }
        list.style.setProperty('--list-height', `${list.scrollHeight}px`)
      })
    }

    variantChanged (variantId) {
      this.variantSellingPlanGroupings.forEach(variantSellingPlanGrouping => {
        variantSellingPlanGrouping.classList.toggle('hidden', variantId !== Number(variantSellingPlanGrouping.dataset.variantId))
        if (variantSellingPlanGrouping.classList.contains('hidden')) { return }

        const options = variantSellingPlanGrouping.querySelectorAll('[data-selling-plan-option]')
        if (options.length > 0) {
          options[0].checked = true
          options[0].dispatchEvent(new Event('change'))
        }
      })
    }

    setupOneTimeVariantSelection() {
      this._oneTimeVariantHandlers = []
      this.oneTimeVariantSelectorOptions.forEach((selectorOption) => {
        const handler = () => this.changeOneTimeVariant(selectorOption.dataset.oneTimeVariantSelectorOption)
        selectorOption.addEventListener('change', handler)
        this._oneTimeVariantHandlers.push({ element: selectorOption, handler })
      })
    }

    changeOneTimeVariant(variantId) {
      this.updateVariantIndicators(variantId)
      if (this.variantIdInput) this.variantIdInput.value = variantId

      const oneTimeWrapper = this.oneTimeVariantSelection.closest('[data-selling-plan-wrapper]')
      const isOneTimeActive = oneTimeWrapper && oneTimeWrapper.classList.contains('active')

      if (this.oneTimeSellingPlanOption) {
        this.oneTimeSellingPlanOption.checked = true
        this.oneTimeSellingPlanOption.dispatchEvent(new Event('change'))
      }

      this.oneTimeVariantSelector?.click()

      requestAnimationFrame(() => {
        if (isOneTimeActive) {
          this.changeOneTimePriceDisplay(true)
        }
        this.updateFreeShippingMessage()
      })
    }

    changeOneTimePriceDisplay(changeBuyButton) {
      const parentWrapper = this.buyboxScope || this.oneTimeVariantSelection?.closest('product-rerender');
      const buyButtonPrice = parentWrapper?.querySelector('[data-buy-button-price]');

      const activeIndicator = Array.from(this.oneTimeVariantIndicators).find(indicator => indicator.classList.contains('active'))
      const selectedOneTimeVariant = activeIndicator || this.querySelector('[data-one-time-variant-indicator].active')

      if (!selectedOneTimeVariant) {
        return
      }

      // Read all price values using getAttribute for consistency
      const percentageOff = selectedOneTimeVariant.getAttribute('data-percentage-off') || '';
      const variantPrice = selectedOneTimeVariant.getAttribute('data-one-time-variant-price') || '';
      const compareAtPrice = selectedOneTimeVariant.getAttribute('data-one-time-variant-compare-at-price') || '';
      const finalVariantPrice =
        selectedOneTimeVariant.getAttribute('data-one-time-final-price') ||
        selectedOneTimeVariant.getAttribute('data-one-time-extra-price') ||
        selectedOneTimeVariant.getAttribute('data-one-time-variant-discounted-price') ||
        variantPrice;
      const discountedVariantPrice = selectedOneTimeVariant.getAttribute('data-one-time-variant-discounted-price') || '';

      const bottleCount = parseInt(selectedOneTimeVariant.getAttribute('data-bottle-count') || '1');
      const productCount = parseInt(selectedOneTimeVariant.getAttribute('data-product-count') || '1');
      const isOneBottle = bottleCount === 1 && productCount === 1;

      const isV2 = this.classList.contains('product-subscriptions-v2');

      if (changeBuyButton && buyButtonPrice) {
        if (isV2) {
          const perBottleDollars = selectedOneTimeVariant.getAttribute('data-per-bottle-dollars')
          const perBottleCentsDisplay = selectedOneTimeVariant.getAttribute('data-per-bottle-cents-display')

          if (perBottleDollars !== null && perBottleCentsDisplay !== null) {
            const perBottlePriceFormatted = `$${perBottleDollars}.${perBottleCentsDisplay} /bottle`
            buyButtonPrice.innerHTML = `${perBottlePriceFormatted} &ndash; `
            this.wrapButtonText(buyButtonPrice)
            this.updateBuyButtonLabel(isOneBottle, parentWrapper)
          }
        } else {
          buyButtonPrice.innerHTML = `${finalVariantPrice} &ndash; `
        }
      }

      if (isV2) {
        const oneTimeWrapper = this.querySelector('.product-subscriptions__subscription--one-time')
        const priceWrapper = oneTimeWrapper?.querySelector('.product-subscriptions__subscription-price-wrapper')
        if (!priceWrapper) return

        const priceDisplayType = selectedOneTimeVariant.getAttribute('data-price-display-type') || 'simple';

        let perBottlePriceCents = 0
        if (isOneBottle) {
          const variantPriceCents = parseInt(selectedOneTimeVariant.getAttribute('data-one-time-variant-price-cents') || '0')
          const finalPriceCents = parseInt(selectedOneTimeVariant.getAttribute('data-one-time-final-price-cents') || variantPriceCents)
          const discountedPriceCents = parseInt(selectedOneTimeVariant.getAttribute('data-one-time-variant-discounted-price-cents') || variantPriceCents)

          if (priceDisplayType === 'sale' && finalPriceCents > 0) {
            perBottlePriceCents = finalPriceCents
          } else if (priceDisplayType === 'discounted' && discountedPriceCents > 0 && discountedPriceCents !== variantPriceCents) {
            perBottlePriceCents = discountedPriceCents
          } else {
            perBottlePriceCents = variantPriceCents
          }
        } else {
          const perBottlePriceCentsRaw = parseFloat(selectedOneTimeVariant.getAttribute('data-per-bottle-price-cents') || '0');
          perBottlePriceCents = Math.round(perBottlePriceCentsRaw);
        }

        const perBottleDollars = Math.floor(perBottlePriceCents / 100);
        const perBottleCentsRemainder = perBottlePriceCents % 100;
        const perBottleCentsDisplay = perBottleCentsRemainder < 10 ? '0' + perBottleCentsRemainder : perBottleCentsRemainder.toString();

        const oneBottlePrice = priceWrapper.getAttribute('data-one-bottle-price') || '';

        priceWrapper.innerHTML = '';

        let priceHTML = '';

        const isSale = priceDisplayType === 'sale';
        const isConvertVariantBuybox = Boolean(this.closest('[data-ab="buybox-variant"]'));
        let showStrikethrough = !isOneBottle || isSale;

        if (isConvertVariantBuybox) {
          const oneBottlePriceCents = parseInt(priceWrapper.getAttribute('data-one-bottle-price-cents') || '0');
          showStrikethrough = isSale || (
            !isOneBottle &&
            oneBottlePriceCents > 0 &&
            perBottlePriceCents < oneBottlePriceCents
          );
        }

        if (oneBottlePrice) {
          if (showStrikethrough) {
            priceHTML += `<div class="product-subscriptions__subscription-price-strikethrough" data-static-strikethrough><s>${oneBottlePrice}</s></div>`;
          } else if (isConvertVariantBuybox) {
            priceHTML += `<div class="product-subscriptions__subscription-price-strikethrough" data-static-strikethrough aria-hidden="true"></div>`;
          } else {
            // Empty placeholder keeps the price column the same height when the strikethrough is hidden.
            priceHTML += `<div class="product-subscriptions__subscription-price-strikethrough" data-static-strikethrough></div>`;
          }
        }

        const totalLabel = isSale ? 'Sale Total' : 'Total';
        const totalClass = isSale
          ? 'product-subscriptions__subscription-price-total product-subscriptions__subscription-price-total--sale'
          : 'product-subscriptions__subscription-price-total';

        priceHTML += `<div class="product-subscriptions__subscription-price-per-bottle">
          <span class="per-bottle-dollar-sign">$</span>
          <span class="per-bottle-dollar">${perBottleDollars}</span>
          <span class="per-bottle-cents-container">
            <span class="per-bottle-cents">${perBottleCentsDisplay}</span>
            <span class="per-bottle-label">/bottle</span>
          </span>
          <span class="sr-only">$${perBottleDollars}.${perBottleCentsDisplay} per bottle</span>
        </div>`;

        if (!isOneBottle || isSale) {
          const totalPrice = finalVariantPrice || variantPrice;
          priceHTML += `<div class="${totalClass}">${totalLabel}: ${totalPrice}</div>`;
        } else if (isConvertVariantBuybox) {
          priceHTML += `<div class="product-subscriptions__subscription-price-total" aria-hidden="true"></div>`;
        }


        priceWrapper.innerHTML = priceHTML;
      } else {
        const oneTimeWrapper = this.querySelector('.product-subscriptions__subscription--one-time')
        const priceDisplay = oneTimeWrapper?.querySelector('[data-one-time-price-display]')
        if (!priceDisplay) return

        if (percentageOff > 0) {
          const preSalePrice =
            discountedVariantPrice && discountedVariantPrice !== variantPrice
              ? discountedVariantPrice
              : variantPrice

          priceDisplay.innerHTML = `
            <span class="product-subscriptions__subscription-price-sale-row">
              <span class="product-subscriptions__subscription-price-presale"><s>${preSalePrice}</s></span>
              <span class="product-subscriptions__subscription-price-current">${finalVariantPrice}</span>
            </span>
          `
          return
        }

        if (finalVariantPrice === variantPrice) {
          priceDisplay.innerHTML = `<strong>${variantPrice}</strong>`;
          return;
        }

        const middle =
          (percentageOff > 0 && !isOneBottle && discountedVariantPrice && discountedVariantPrice !== variantPrice)
            ? `<s class="text-subdued"><strong>${discountedVariantPrice}</strong></s><br>`
          : (discountedVariantPrice && discountedVariantPrice !== variantPrice)
            ? `<strong>${discountedVariantPrice}</strong>`
            : '';


        priceDisplay.innerHTML = `
    ${percentageOff > 0 ? `<strong class="finalvariantprice">${finalVariantPrice}</strong><br>` : ''}
     <strong class="discounted-container"> ${middle}
      <s class="text-subdued float-none">${variantPrice}</s> </strong>
    `;
      }
    }

    formatMoneyFromCents(cents) {
      if (window.themeVariables && window.themeVariables.settings.moneyFormat) {
        const amount = (cents / 100).toFixed(2);
        return window.themeVariables.settings.moneyFormat.replace('{{amount}}', amount);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    updateFreeShippingMessage() {
      if (!this.freeShippingMessage || !this.classList.contains('product-subscriptions-v2')) {
        return
      }

      const runUpdate = () => {
        const oneTimeWrapper = this.querySelector('.product-subscriptions__subscription--one-time')
        const isOneTimeActive = oneTimeWrapper && oneTimeWrapper.classList.contains('active')

        if (!isOneTimeActive) {
          this.freeShippingMessage.classList.remove('hidden')
          return
        }

        const activeIndicator = Array.from(this.oneTimeVariantIndicators).find(indicator => indicator.classList.contains('active'))
        if (!activeIndicator) {
          this.freeShippingMessage.classList.remove('hidden')
          return
        }

        const bottleCount = parseInt(activeIndicator.getAttribute('data-bottle-count') || '1')
        const productCount = parseInt(activeIndicator.getAttribute('data-product-count') || '1')
        const isOneBottle = bottleCount === 1 && productCount === 1

        if (isOneBottle) {
          this.freeShippingMessage.classList.add('hidden')
        } else {
          this.freeShippingMessage.classList.remove('hidden')
        }
      }

      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(runUpdate, { timeout: 100 })
      } else {
        requestAnimationFrame(runUpdate)
      }
    }

  }

  window.customElements.define('product-subscriptions', productSubscriptions)  
}
